const settlementEvents = [

    /*{
        "name": "Acid Storm",
        "Tags": "Core",
        "rules": "At some point in your life, you learned a miraculous thing! You cannot recall who taught you or what it was. For a moment, you see a spectrum of colors in your blood . The first time you gain a bleeding token during the showdown, gain +1 survival.",
        "Lingering Effects": "When Endeavor is spent at Bloodletting or Sacrifice, gain +1 Observation",
    },*/

    {
        "name": "Acid Storm",
        "Tags": "Core",
        "rules": "The air tastes sour and burns the survivors' cracked lips.\nThe sky cracks in great flashes, revealing spiraling black clouds.\nFinally it opens, dousing everything in acid rain.\nRoll 1d10."+
                 "1: Each **returning survivor** must archive a gear card of their choice.\n2-5: The survivor with the highest insanity (randomize in case of ties) runs into the storm bellowing wildly. They must skip the next hunt.\n"+
                 "Some of the debris around the settlement becomes useful due to the strange effects of the storm. Add 1 Scrap to settlement storage.",
        "Lingering Effects": "The storm prevents **Music** Endeavors.\nThe storm inspires. +2 to the result of all **Art** Endeavors.\n\n"+
                 "Requires Nightmare Trainging:\nenDeavour Acid Storm Exercise - roll 1d10\n1-5: The survivor is burned to death\n6-7: You are injured and must skip the next hunt.\n"+
                 "8+: You gain the following ability. **Acid Palms**: Add 1d10 strength to wound attempts when attacking with Fist & Tooth."+
                 "Requires Cooking:\nenDeavour Acid Storm Distillation - roll 1d10\n1-4: Nothing happens\n5+: Gain a **Founding Stone** starting gear",
    },
    {
        "name": "Clinging Mist",
        "Tags": "Core",
    },
    {
        "name": "Cracks in the Ground",
        "Tags": "Core",
    },
    {
        "name": "Dark Dentist",
        "Tags": "Core",
    },
    {
        "name": "Dark Trader",
        "Tags": "Core",
    },
    {
        "name": "Elder Council",
        "Tags": "Core",
    },
    {
        "name": "First Day",
        "Tags": "Core",
    },
    {
        "name": "Glossolalia",
        "Tags": "Core",
    },
    {
        "name": "Haunted",
        "Tags": "Core",
    },
    {
        "name": "Heat Wave",
        "Tags": "Core",
    },
    {
        "name": "Hunt Reenactment",
        "Tags": "Core",
    },
    {
        "name": "Lights in the Sky",
        "Tags": "Core",
    },
    {
        "name": "Murder",
        "Tags": "Core",
    },
    {
        "name": "Nickname",
        "Tags": "Core",
    },
    {
        "name": "Open Maw",
        "Tags": "Core",
    },
    {
        "name": "Plague",
        "Tags": "Core",
    },
    {
        "name": "Rivalry ",
        "Tags": "Core",
    },
    {
        "name": "Skull Eater",
        "Tags": "Core",
    },
    {
        "name": "Stranger in the Dark",
        "Tags": "Core",
    },
    {
        "name": "Triathlon of Death",
        "Tags": "Core",
    },
    {
        "name": "Weird Dream",
        "Tags": "Core",
    },

    //Gambler's Chest
    {
        "name": "Ballad of the Butcher",
        "Tags": "Seed",
    },
    {
        "name": "Birth",
        "Tags": "Gamblers Chest",
    },
    {
        "name": "Concert",
        "Tags": "Smog Singer",
    },
    {
        "name": "Death",
        "Tags": "Gamblers Chest",
    },
    {
        "name": "First Crimson Day",
        "Tags": "Crimson Crocodile",
    },
    {
        "name": "Mysterious Eggs",
        "Tags": "Gamblers Chest",
    },
    {
        "name": "Murder",
        "Tags": "Gambler's Chest",
    },
    {
        "name": "Shapes in the Darkness",
        "Tags": "Gamblers Chest",
    },
    {
        "name": "Skull Eater",
        "Tags": "Gambler's Chest",
    },
    {
        "name": "Velvet Frog",
        "Tags": "Gamblers Chest",
    },
    //Black Knight Expansion
    {
        "name": "It Rang",
        "Tags": "Black Knight",
    },
    {
        "name": "Jousting!",
        "Tags": "Black Knight",
    },
    {
        "name": "Knighting",
        "Tags": "Black Knight",
    },
    //Slenderman Expansion
    {
        "name": "Phantom",
        "Tags": "Slenderman",
    },
    {
        "name": "Slender Blight",
        "Tags": "Slenderman",
    },
    //Gorm Expansion
    {
        "name": "Gorm Climate",
        "Tags": "Gorm",
    },
    //Spidicules Expansion
    {
        "name": "Season of the Spiderling",
        "Tags": "Spidicules",
    },
    {
        "name": "Silk Storm",
        "Tags": "Spidicules",
    },
    //White Box Expansion
    {
        "name": "A Strange Spot",
        "Tags": "White Box",
    },
    {
        "name": "Dark Seamstress",
        "Tags": "White Box",
    },
    {
        "name": "Story in the Snow",
        "Tags": "White Box",
    },
    {
        "name": "Sword Hunter",
        "Tags": "White Box",
    },{
        "name": "The Plant and the Stone",
        "Tags": "White Box",
    },

];


export default settlementEvents;